/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { AssetDTO } from './asset';
import { BaseService } from './base';

export interface DeviceDTO {
    id: string;
    type: string;
    name?: string;
    networkId1: string;
    networkId2?: string;
    description?: string;
    assigned?: string; // Name of assigned device
    usage: number;
    simStatus: string;
    carrier: string;
    lastSeen: string;
    sim: string;
    firmware: string;
}

export class DeviceService extends BaseService {
    public async init() {
        return new Promise((resolve, _reject) => {
            console.log('Device Service Loaded');
            resolve('Loaded');
        });
    }

    /**
     *
     * @returns
     */
    async getDevices() {
        const response = await this.get<DeviceDTO[]>(this.url + '/api/' + this.orgid + '/devices');
        return response;
    }

    /** API call to save a device
     *  @device [DeviceDTO] device information to save.
     */
    async saveDevice(device: DeviceDTO, createAsset: boolean) {
        const response = await this.post<DeviceDTO>(this.url + '/api/' + this.orgid + '/device?asset=' + createAsset, device);
        return response;
    }

    async updateDevice(device: DeviceDTO) {
        const response = await this.put<DeviceDTO>(this.url + '/api/' + this.orgid + '/device', device);
        return response;
    }

    async deleteDevice(id: string) {
        const response = await this.delete<DeviceDTO>(this.url + '/api/' + this.orgid + '/device', id);
        return response;
    }

    async findDevicesForAsset(asset: AssetDTO | undefined) {
        let url = '';
        if (asset != undefined) {
            url = this.url + '/api/' + this.orgid + '/device/assigned?asset=' + asset?.id.id + '&available=true';
        } else {
            url = this.url + '/api/' + this.orgid + '/device/assigned?available=true';
        }

        const response = await this.get<DeviceDTO[]>(url);
        return response;
    }
}
